import { Block, Flex, Icon, Tooltip, Typography } from '@aloft/toolkit-sui';

import { Controller, FormProvider, UseFormReturn } from 'react-hook-form';
import z from 'zod';

import { CertifyModalForm } from '../schemas.ts';
import { Textarea } from '@aloft/toolkit-sui/chakra';

export const CertifyModalCommentary = ({
  form,
}: {
  form: UseFormReturn<z.input<CertifyModalForm>>;
}) => (
  <FormProvider {...form}>
    <Flex flexDirection="column">
      <Flex gap={2} alignItems="center" marginBottom="5px">
        <Typography variant="h3" color="textSecondary">
          Additional Certification Commentary
        </Typography>
        <Block marginBottom="-8px">
          <Tooltip
            label="Add custom certification commentary, disclaimers, or additional disclosures to your appraisal report."
            marginBottom="-8px"
          >
            <Icon icon="information" color="textSecondary" />
          </Tooltip>
        </Block>
      </Flex>
      <Controller
        name="certificationCommentary"
        control={form.control}
        render={({ field }) => <Textarea resize="none" {...field} />}
      />
    </Flex>
  </FormProvider>
);
